import React, { useEffect, useState } from 'react';
import { CustomizationImage, CustomizationValue } from './CustomizationBase';
import { DividedContainer } from './DividedContainer';
import { Col, Row } from 'react-bootstrap';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import MediaQuery from 'react-responsive';
import Heading from '../heading/Heading';

function CustomizationAddOn(_ref) {
  var header = _ref.header,
      headline = _ref.headline,
      options = _ref.options,
      selected = _ref.value,
      _onChange = _ref.onChange;
  var items = options.map(function (product) {
    return /*#__PURE__*/React.createElement(Col, {
      lg: 3,
      md: 4,
      sm: 12,
      className: "pb-12",
      key: product.ProductChainId
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      name: "addon",
      id: product.ProductChainId,
      className: "visuallyhidden",
      checked: selected === product.ProductChainId,
      onChange: function onChange(e) {
        return _onChange(e.target.checked ? product.ProductChainId : undefined);
      }
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: product.ProductChainId,
      className: "cb-menu-detail__selectable-addon"
    }, /*#__PURE__*/React.createElement(CustomizationImage, {
      media: {
        value: {
          src: product.ImageUrl,
          alt: product.DisplayName
        }
      },
      className: "cb-menu-detail__image"
    }), /*#__PURE__*/React.createElement("div", {
      className: "cb-menu-detail__selectable-addon--bottom"
    }, product.DisplayName ? /*#__PURE__*/React.createElement(RichText, {
      field: {
        value: typeof product.DisplayName === "string" ? product.DisplayName : String(product.DisplayName)
      }
    }) : null, /*#__PURE__*/React.createElement(DividedContainer, {
      className: "p-0 flex-md-column align-items-md-start"
    }, product.Calories ? /*#__PURE__*/React.createElement(CustomizationValue, {
      value: {
        value: typeof product.Calories === "string" ? product.Calories : String(product.Calories)
      },
      extraMarkupCalorie: " calories"
    }) : null, product.ListPrice ? /*#__PURE__*/React.createElement(CustomizationValue, {
      value: {
        value: typeof product.ListPrice === "string" ? product.ListPrice : String(product.ListPrice)
      },
      extraMarkupPrice: "+$"
    }) : null))));
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
    level: 3,
    field: {
      value: header
    }
  }), /*#__PURE__*/React.createElement(Heading, {
    level: 4,
    field: {
      value: headline
    }
  }), /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", {
    className: "visuallyhidden"
  }, headline), /*#__PURE__*/React.createElement(Row, {
    className: "cb-menu-detail__customization-group"
  }, items)));
}

export default CustomizationAddOn;